import { Tooltip, withStyles } from '@material-ui/core'
import React from 'react'

export const GreyTooltip = withStyles({
  tooltip: { color: 'white', backgroundColor: '#9e9e9e' },
})(Tooltip)
